import { ReactNode, Dispatch, SetStateAction } from 'react';
import { Box, Button, makeStyles } from '@material-ui/core';
import { WbButton } from '../WbButton';
import { MultiSelectionContent } from './MultiSelectionContent';
import { useMultiSelectionPickerContext } from './MultiSelectionPickerContext';

const useStyles = makeStyles(
  theme => ({
    actions: {
      padding: theme.spacing(1),
      position: 'sticky',
      bottom: 0,
      borderTop: `1px solid ${theme.palette.grey[300]}`,
      background: theme.palette.white,
      display: 'flex',
      justifyContent: 'end',
      gap: theme.spacing(1),
    },
  }),
  { name: 'MultiSelection-content' },
);

export interface WbMultiSelectionPickerProps<T> {
  title: string;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  selectedValues: T[];
  setSelectedValues: Dispatch<SetStateAction<T[]>>;
  children: ReactNode;
  fetchAiData?: () => Promise<T[]>;
  onApply?: (values: T[]) => {};
  contentHeader?: JSX.Element;
  contentHeight?: string;
}

export function PickerContent<T>({
  fetchAiData,
  setOpen,
  children,
  title,
  onApply,
  contentHeader,
  contentHeight,
}: WbMultiSelectionPickerProps<T>) {
  const classes = useStyles();
  const { setSelectedValues, contextSelected } =
    useMultiSelectionPickerContext();

  return (
    <>
      <MultiSelectionContent
        aiEnabled={!!fetchAiData}
        title={title}
        setOpen={setOpen}
        contentHeight={contentHeight}
        contentHeader={contentHeader}
      >
        {/* left content */}
        {children}
      </MultiSelectionContent>
      <Box className={classes.actions}>
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={() => {
            setOpen(false);
          }}
        >
          Cancel
        </Button>
        <WbButton
          onClick={() => {
            onApply?.(contextSelected);
            setSelectedValues(contextSelected);
            setOpen(false);
          }}
          variant="contained"
          size="small"
          color="primary"
          label="Apply"
        />
      </Box>
    </>
  );
}
